export default function DownChevron() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <polygon fill="#333" points="16.137 9 17.5 10.39 12 16 6.5 10.39 7.863 9 12 13.22" />
    </svg>
  );
}
